import { hasAnalyticsConsent } from 'dashboard/helper/AnalyticsHelper/utils/trackingEnvelope';

export const INTERCOM_BOOT = 'boot';
export const INTERCOM_SHUTDOWN = 'shutdown';
export const INTERCOM_SCRIPT_URL = 'https://widget.intercom.io/widget/';
export const INTERCOM_ALIGNMENT = 'left';

const safeWindow = win => {
  if (win) return win;
  if (typeof window === 'undefined') return null;
  return window;
};

export const intercomAppId = win =>
  safeWindow(win)?.thirdPartySdkConfig?.intercomAppId ||
  safeWindow(win)?.globalConfig?.INTERCOM_APP_ID ||
  '';

const userHasCompleteIntercomIdentity = user =>
  Boolean(user?.email && user?.name && user?.phone_number && user?.id);

export const defineIntercomSettings = ({ user, appId }) => {
  const base = {
    app_id: appId,
    alignment: INTERCOM_ALIGNMENT,
  };

  if (!userHasCompleteIntercomIdentity(user)) return base;

  return {
    ...base,
    email: user.email,
    name: user.name,
    phone: user.phone_number,
    user_id: String(user.id),
  };
};

const canUseIntercom = ({ featureEnabled, consent, appId }) =>
  Boolean(featureEnabled && consent && appId);

export const bootIntercom = ({
  user,
  featureEnabled = false,
  consent = hasAnalyticsConsent(),
  appId = intercomAppId(),
  win,
} = {}) => {
  const currentWindow = safeWindow(win);
  if (!currentWindow || !canUseIntercom({ featureEnabled, consent, appId })) {
    return false;
  }

  const settings = defineIntercomSettings({ user, appId });
  if (typeof currentWindow.Intercom === 'function') {
    currentWindow.Intercom(INTERCOM_BOOT, settings);
    return true;
  }

  currentWindow.intercomSettings = settings;
  return false;
};

export const shutdownIntercom = ({ win } = {}) => {
  const currentWindow = safeWindow(win);
  if (!currentWindow) return false;

  if (typeof currentWindow.Intercom === 'function') {
    currentWindow.Intercom(INTERCOM_SHUTDOWN);
  }
  delete currentWindow.Intercom;
  delete currentWindow.intercomSettings;
  return true;
};
